import { featuredPosts } from '@/mocks/haijiao';

export default function FeatureFlow() {
  return (
    <section id="flow" className="border-b border-stone-200/80 bg-[#fdfaf6]">
      <div className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-14">
        <div className="flex items-end justify-between gap-4">
          <div>
            <p className="flex items-center gap-2 text-sm font-semibold text-orange-600">
              <i className="ri-image-2-fill"></i> 大图卡片流 · 圈子精选
            </p>
            <h2 className="mt-2 text-xl font-bold tracking-tight text-stone-900 md:text-2xl">
              配图精选：一篇篇带你进圈子，看图也想点进来
            </h2>
          </div>
          <span className="hidden shrink-0 whitespace-nowrap text-xs text-stone-400 sm:block">图文并茂 · 每日更新</span>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {featuredPosts.map((p, i) => (
            <a
              key={i}
              href="#top"
              className="group flex flex-col overflow-hidden rounded-2xl border border-stone-200 bg-white transition-colors hover:border-orange-300"
            >
              <div className="relative aspect-[4/3] w-full overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-stone-900/70 px-2.5 py-1 text-[11px] font-medium text-white backdrop-blur">
                  {p.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <div className="flex items-center gap-2 text-xs text-orange-700">
                  <i className="ri-community-line"></i>
                  <span className="whitespace-nowrap">{p.board}</span>
                </div>
                <h3 className="mt-2 flex-1 text-sm font-bold leading-snug text-stone-900 md:text-[15px]">{p.title}</h3>
                <div className="mt-3 flex items-center gap-4 border-t border-stone-100 pt-3 text-xs text-stone-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {p.reads}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i> {p.replies}
                  </span>
                  <span className="ml-auto flex items-center gap-1 text-orange-500">
                    去讨论 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}